import { AnalyticsBrandSettings, AnalyticsEventData } from 'idt-analytics-api/models';
import { getDefaultAnalytics } from '../helpers/events.helper';
import { AnalyticsGTMSettings, DefaultAnalyticsSettings } from 'analytics-api';
import { AnalyticsOyshoEventDataHelpers } from '../helpers/brand-analytics-event-data.helpers.oy';

export const MainMenuEvents: AnalyticsBrandSettings = {

  menuPrincipalNavegacionClickCategoria(data: AnalyticsEventData): AnalyticsGTMSettings {
    const { componentData, context } = data;
    const categoryUrl = componentData.url;
    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'navegacion', 'menu_principal', 'click_categoria', categoryUrl);
    return AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
  },

  menuPrincipalPerfilUsuarioVerCuenta(data: AnalyticsEventData): AnalyticsGTMSettings {
    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'perfil_usuario', 'menu_principal', 'ver_cuenta');
    return AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
  },

  menuPrincipalPerfilUsuarioIniciarSesion(data: AnalyticsEventData): AnalyticsGTMSettings {
    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'perfil_usuario', 'menu_principal', 'iniciar_sesion');
    return AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
  },

  menuPrincipalNavegacionIrAHome(data: AnalyticsEventData): AnalyticsGTMSettings {
    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'navegacion', 'menu_principal', 'ir_a_home');
    return AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
  },

  menuPrincipalCatalogoVerMasInformacion(data: AnalyticsEventData): AnalyticsGTMSettings {
    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'catalogo', 'menu_principal', 'ver_mas_informacion');
    return AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
  },

  menuPrincipalLocalizadorTiendasIrALocalizadorTiendas(data: AnalyticsEventData): AnalyticsGTMSettings {
    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'localizador_tiendas', 'menu_principal', 'ir_a_localizador_tiendas');
    return AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
  },

  menuPrincipalGiftCardVerGiftCard(data: AnalyticsEventData): AnalyticsGTMSettings {
    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'gift_card', 'menu_principal', 'ver_gift_card');
    return AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
  },

  menuPrincipalGiftCardComprarGiftCard(data: AnalyticsEventData): AnalyticsGTMSettings {
    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'gift_card', 'menu_principal', 'comprar_gift_card');
    return AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
  },

  menuPrincipalGiftCardActivarGiftCard(data: AnalyticsEventData): AnalyticsGTMSettings {
    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'gift_card', 'menu_principal', 'activar_gift_card');
    return AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
  },

  menuPrincipalGiftCardConsultarSaldo(data: AnalyticsEventData): AnalyticsGTMSettings {
    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'gift_card', 'menu_principal', 'consultar_saldo');
    return AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
  },

  menuPrincipalCorporativoEmpresa(data: AnalyticsEventData): AnalyticsGTMSettings {
    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'corporativo', 'menu_principal', 'empresa');
    return AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
  },

  menuPrincipalCorporativoVerQuienesSomos(data: AnalyticsEventData): AnalyticsGTMSettings {
    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'corporativo', 'menu_principal', 'ver_quienes_somos');
    return AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
  },

  menuPrincipalCorporativoVerPrensa(data: AnalyticsEventData): AnalyticsGTMSettings {
    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'corporativo', 'menu_principal', 'ver_prensa');
    return AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
  },

  menuPrincipalLegalVerPoliticaPrivacidad(data: AnalyticsEventData): AnalyticsGTMSettings {
    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'legal', 'menu_principal', 'ver_politica_privacidad');
    return AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
  },

  menuPrincipalLegalVerCookies(data: AnalyticsEventData): AnalyticsGTMSettings {
    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'legal', 'menu_principal', 'ver_cookies');
    return AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
  },

  menuPrincipalCorporativoVerMedioambiental(data: AnalyticsEventData): AnalyticsGTMSettings {
    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'corporativo', 'menu_principal', 'ver_medioambiental');
    return AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
  },

  menuPrincipalNewsletterVerNewsletter(data: AnalyticsEventData): AnalyticsGTMSettings {
    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'newsletter', 'menu_principal', 'ver_newsletter');
    return AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
  },

  menuPrincipalConfiguracionCambioRegion(data: AnalyticsEventData): AnalyticsGTMSettings {
    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'configuracion', 'menu_principal', 'cambio_region');
    return AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
  },

  menuPrincipalAyudaVerAyuda(data: AnalyticsEventData): AnalyticsGTMSettings {
    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'ayuda', 'menu_principal', 'ver_ayuda');
    return AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
  },

  menuPrincipalAyudaVerContacto(data: AnalyticsEventData): AnalyticsGTMSettings {
    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'ayuda', 'menu_principal', 'ver_contacto');
    return AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
  },

  menuPrincipalAyudaVerFaq(data: AnalyticsEventData): AnalyticsGTMSettings {
    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'ayuda', 'menu_principal', 'ver_faq');
    return AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
  },

  menuPrincipalAyudaVerEnvio(data: AnalyticsEventData): AnalyticsGTMSettings {
    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'ayuda', 'menu_principal', 'ver_envio');
    return AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
  },

  menuPrincipalAyudaVerGuiaTallas(data: AnalyticsEventData): AnalyticsGTMSettings {
    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'ayuda', 'menu_principal', 'ver_guia_tallas');
    return AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
  },

  menuPrincipalAyudaVerWallet(data: AnalyticsEventData): AnalyticsGTMSettings {
    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'ayuda', 'menu_principal', 'ver_wallet');
    return AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
  },

  menuPrincipalAyudaVerTicketElectronico(data: AnalyticsEventData): AnalyticsGTMSettings {
    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'ayuda', 'menu_principal', 'ver_ticket_electronico');
    return AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
  },

  menuPrincipalAyudaVerCondicionesCompra(data: AnalyticsEventData): AnalyticsGTMSettings {
    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'ayuda', 'menu_principal', 'ver_condiciones_compra');
    return AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
  }

};
